import React, { Fragment } from "react";
import {
  AuthCompanyContext,
  useRedirectToExternalLink,
  useHasRole,
  useAuth
} from "@homesusa/auth";
import { RoleEmployee } from "@homesusa/core";
import { AppContext, AppType, Button, useTheme } from "@homesusa/layout";
import { UserContext } from "../contexts";
import { toolbarButtonSx } from "./user-toolbar.style";

export function ReportManagementButton(): JSX.Element {
  const { currentEmployee, currentCompany } =
    React.useContext(AuthCompanyContext);
  const { hasEmployeeRole } = useHasRole();
  const { user: currentLoggedUser } = useAuth();
  const {
    appState: { apps }
  } = React.useContext(AppContext);
  const { variant } = useTheme();
  const reidrectToUrl = useRedirectToExternalLink();
  const { user } = React.useContext(UserContext);

  if (!currentEmployee || currentLoggedUser?.id != user?.id) {
    return <></>;
  }

  return (
    <Fragment>
      {currentCompany &&
        hasEmployeeRole([
          RoleEmployee.CompanyAdmin,
          RoleEmployee.SalesEmployee
        ]) && (
          <Button
            variant={variant === "new" ? "outlined" : "contained"}
            sx={variant === "new" ? toolbarButtonSx : undefined}
            onClick={() =>
              reidrectToUrl(
                `${apps[AppType.CompanyManagement]}/companies/${currentCompany.id}/employees/${currentEmployee.id}`
              )
            }
          >
            Report Management
          </Button>
        )}
    </Fragment>
  );
}
